<template>
  <div>
    <v-subheader>Select a category from the list of categories</v-subheader>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
